var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFleetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6082 2.40638C15.2134 2.27479 14.7866 2.27479 14.3918 2.40638L4.80262 5.60276L15 9.00192L25.1974 5.60276L15.6082 2.40638ZM27.6923 7.20369L16.1538 11.0498V27.0788L26.3774 23.671C27.1626 23.4092 27.6923 22.6744 27.6923 21.8466V7.20369ZM13.8462 27.0788V11.0498L2.30769 7.20369V21.8466C2.30769 22.6744 2.83737 23.4092 3.62264 23.671L13.8462 27.0788ZM13.6621 0.217108C14.5305 -0.0723692 15.4695 -0.0723692 16.3379 0.217108L29.211 4.50815C29.6822 4.66522 30 5.10615 30 5.60276V21.8466C30 23.6677 28.8347 25.2844 27.1072 25.8603L15.3648 29.7744C15.128 29.8533 14.872 29.8533 14.6352 29.7744L2.89288 25.8603C1.16528 25.2844 0 23.6677 0 21.8466V5.60276C0 5.10615 0.317808 4.66522 0.788969 4.50815L13.6621 0.217108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetIcon);
export default __webpack_public_path__ + "static/media/fleet_icon.180bc2a69a4352ea734e7bcd50b38de1.svg";
export { ForwardRef as ReactComponent };